import React, { useEffect, useRef, useState } from "react";
import ModalImage from "react-modal-image";
import { useDispatch, useSelector } from "react-redux";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import {
  createSelfIntroMedia,
  deleteSelfIntroMedia,
  fetchSelfIntroMedia,
  updateSelfIntroMedia,
} from "../../store/portfolio/action";
import "./SelfIntroMedia.scss";
import { CANDIDATE_URL } from "@workspace/common/src/config";
import { CANDIDATES } from "@workspace/common/src/baseUrl";

function SelfIntroMedia({ candidateId, editable, publicView }) {
  const dispatch = useDispatch();
  const fileInputRef = useRef(null);
  const updateFileInputRef = useRef(null);

  const candidateMedia = useSelector(
    (state) => state.PortfolioReducer.selfIntroMedia
  );
  const [selfIntroMedia, setSelfIntroMedia] = useState(null);
  const [deleteModal, setDeleteModal] = useState(false);

  // Retrieve Image
  useEffect(() => {
    if (candidateId != null && candidateId !== "") {
      dispatch(fetchSelfIntroMedia(candidateId));
    }
  }, [candidateId, selfIntroMedia]);

  // Set Image
  useEffect(() => {
    if (candidateMedia) {
      if (candidateMedia?.fileName !== null) {
        const filePath = `${CANDIDATE_URL}${CANDIDATES}/candidate-media/view/${candidateMedia?.fileName}`;
        setSelfIntroMedia(filePath);
      } else {
        setSelfIntroMedia(null);
      }
    }
  }, [candidateMedia]);

  // Set Input File
  const handleFileUploadClick = () => {
    fileInputRef.current.click();
  };

  // Set Update Input File
  const handleUpdateFileUploadClick = () => {
    updateFileInputRef.current.click();
  };

  // Upload Image
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append("file", file);
    formData.append("candidateId", candidateId);

    dispatch(createSelfIntroMedia(formData));
  };

  // Confirm Delete
  const confirmDelete = () => {
    setDeleteModal(true);
  };

  // Delete Image
  const handleDelete = () => {
    setDeleteModal(false);
    dispatch(deleteSelfIntroMedia(candidateMedia?.id));
    setSelfIntroMedia(null);
  };

  // Update Image
  const handleUpdateFile = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append("file", file);

    dispatch(
      updateSelfIntroMedia({ id: candidateMedia?.id, formData: formData })
    );
  };

  return (
    <div>
      <div>
        {selfIntroMedia ? (
          <div className="portfolio-image-wrapper">
            <div
              className="portfolio-image-overlay"
              style={{ visibility: publicView ? "hidden" : "visible" }}
            >
              <span
                className="mdi mdi-circle-edit-outline portfolio-image-mdi"
                onClick={handleUpdateFileUploadClick}
              ></span>
              <span
                className="mdi mdi-delete-outline portfolio-image-mdi"
                onClick={() => confirmDelete()}
              ></span>
              <input
                type="file"
                ref={updateFileInputRef}
                style={{ display: "none" }}
                onChange={handleUpdateFile}
              />
            </div>

            <ModalImage
              small={selfIntroMedia}
              large={selfIntroMedia}
              hideDownload={true}
              hideZoom={true}
              className="portfolio-image"
            />
          </div>
        ) : (
          <div className={`${publicView ? "" : "self-intro-empty"}`}>
            <div
              style={{ borderRadius: "15px" }}
              className="p-3 d-flex flex-column align-items-center justify-content-center"
            >
              {publicView ? null : (
                <>
                  <span
                    className="text-center"
                    style={{
                      fontWeight: "100",
                      color: "#3256ED",
                      fontSize: "20PX",
                    }}
                  >
                    Click here to upload self intro media.
                  </span>
                  <div>
                    <span
                      onClick={handleFileUploadClick}
                      style={{ fontSize: "55px", color: "#3256ED" }}
                      className="mdi mdi-progress-upload cursor-pointer"
                    ></span>
                    <input
                      type="file"
                      ref={fileInputRef}
                      style={{ display: "none" }}
                      onChange={handleFileChange}
                    />
                  </div>
                </>
              )}
            </div>
          </div>
        )}
      </div>
      <Modal
        centered
        backdrop="static"
        isOpen={deleteModal}
        toggle={() => setDeleteModal(!deleteModal)}
      >
        <ModalHeader toggle={() => setDeleteModal(!deleteModal)}>
          Delete Portfolio Image
        </ModalHeader>
        <ModalBody>
          Are you sure you would like to delete your portfolio profile image?
        </ModalBody>
        <ModalFooter>
          <Button
            className="btn btn-light"
            onClick={() => setDeleteModal(!deleteModal)}
          >
            Cancel
          </Button>
          <Button className="btn btn-danger" onClick={() => handleDelete()}>
            Delete
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
}

export default SelfIntroMedia;
